import { render, staticRenderFns } from "./Dashboard2.vue?vue&type=template&id=813d37b4"
import script from "@/scripts/dashboard/dashboard2.js?vue&type=script&lang=js&external"
export * from "@/scripts/dashboard/dashboard2.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports